import {
  AddOneSlotToLoadingQueue,
  RemoveOneSlotToLoadingQueue,
} from "../../loading/loading.store";
import ShowNotification from "../../../../components/react-notifications/react-notifications";
import { NotificationMessageType } from "../../../../utils/configuration";
import { ApiUrl } from "../../../../api/api-url";
import Service from "../../../../api/api-service";
import { CONSTANT } from "../../../../constants/constant";
const service = new Service();

export const GET_USER_BY_DEP_OK = "GET_USER_BY_DEP_OK";
export const GET_USER_BY_DEP_ERR = "GET_USER_BY_DEP_ERR";

export const userAction = {
  getUserByDeparment,
};

function getUserByDeparmentOk(payload) {
  return { type: GET_USER_BY_DEP_OK, payload };
}
function getUserByDeparmentErr(payload) {
  return { type: GET_USER_BY_DEP_ERR, payload };
}

function getUserByDeparment(callback) {
  return function (dispatch) {
    dispatch(AddOneSlotToLoadingQueue);
    return service
      .get(ApiUrl.GetUserByDepartment + "?pageIndex=1&pageSize=100000")
      .then((response) => {
        dispatch(getUserByDeparmentOk(response));
        dispatch(RemoveOneSlotToLoadingQueue);
        callback();
      })
      .catch((error) => {
        dispatch(getUserByDeparmentErr(error));
        dispatch(RemoveOneSlotToLoadingQueue);
        if (error && error.errorMessage) {
          ShowNotification(error.errorMessage, NotificationMessageType.Error);
        } else {
          ShowNotification(
            CONSTANT.message.error_unknown,
            NotificationMessageType.Error
          );
        }
      });
  };
}
